import { render, staticRenderFns } from "./SongChordEditorModal.vue?vue&type=template&id=50170c5b&scoped=true"
import script from "./SongChordEditorModal.vue?vue&type=script&lang=ts"
export * from "./SongChordEditorModal.vue?vue&type=script&lang=ts"
import style0 from "./SongChordEditorModal.vue?vue&type=style&index=0&id=50170c5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50170c5b",
  null
  
)

export default component.exports